<div class="auth-header">
  <div class="container">
    <nav
      class="navbar navbar-expand-lg navbar-light container d-flex align-items-center justify-content-between"
    >
      <!-- Logo -->
      <a class="navbar-brand d-flex align-items-center" [routerLink]="APP_ROUTES.GUEST.ROOT">
        <img [src]="ASSETS.logo" alt="Company Logo" class="auth-header__logo" />
      </a>
      <!-- @if (!userProfile) { -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#preloginNavbar"
        aria-controls="preloginNavbar"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-end" id="preloginNavbar">
        <ul class="navbar-nav auth-header__actions">
          <!-- <li class="nav-item">
            <i class="fa-regular fa-circle-question auth-header__icon"></i>
            <a class="auth-header__link" href="javascript:void(0)" (click)="navigateToHelpCenter()">
              Need Help?
            </a>
          </li> -->
          <li class="nav-item">
            <i class="bi bi-globe2 auth-header__icon"></i>
            <select class="auth-header__select">
              <option value="">English</option>
            </select>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>
